import HttpUtil from '../HttpUtil'
let configDomain = process.env.DOMAIN

const refundApi = {
  getRefundList (params) {
    return HttpUtil.get(configDomain + '/buyer/order/refund/list', params)
  },
  setRefundApi (params) {
    return HttpUtil.post(`${configDomain}/buyer/order/refund/apply`, params)
  },
  getRefundReason () {
    return HttpUtil.get(`${configDomain}/bshop/config/dict/list`, { dictCode: 'REFUND_REASON' })
  },
  getRefundDetail (params) {
    return HttpUtil.get(`${configDomain}/buyer/order/refund/detail`, params)
  },
  cancelRefund (params) {
    return HttpUtil.post(`${configDomain}/buyer/order/refund/cancel`, params)
  },
  updateRefund (params) {
    return HttpUtil.post(`${configDomain}/buyer/order/refund/renew`, params)
  },
  uploadImg (params) {
    return HttpUtil.post(`${configDomain}/bshop/config/file/uploadOut`, params, true)
  }
}

export default refundApi
